import { createAsyncThunk } from '@reduxjs/toolkit';
import { Interaction } from '@constants';
import { WarmupDataKey } from '@services/WarmupData';
import { canAddNewPaymentMethod } from '@utils/app';
import { type ThunkApiConfig } from '../store.types';

export const getIsRecurringSupported = createAsyncThunk<
  boolean,
  string,
  ThunkApiConfig
>('paymentMethods/fetch', async (accountId, { extra }) => {
  const { flowAPI, warmupData, paymentMethodsApi } = extra;
  const { environment, errorHandler, panoramaClient } = flowAPI;

  try {
    panoramaClient.transaction(Interaction.LoadRecurringPaymentMethods).start();

    if (environment.isViewer) {
      const methods = await paymentMethodsApi.getRecurringPaymentMethods(
        accountId,
      );
      panoramaClient
        .transaction(Interaction.LoadRecurringPaymentMethods)
        .finish();

      const canAddNewMethod = canAddNewPaymentMethod(methods || []);
      warmupData.set(WarmupDataKey.CanAddNewPaymentMethod, canAddNewMethod);

      return canAddNewMethod;
    }

    panoramaClient
      .transaction(Interaction.LoadRecurringPaymentMethods)
      .finish();
    return true;
  } catch (error) {
    const resolvedError = errorHandler.getResolvedError(error);

    console.error('[my-wallet]:', resolvedError);

    if (error instanceof Error) {
      panoramaClient
        .logger()
        .error(Interaction.LoadRecurringPaymentMethods, { error });
      panoramaClient.errorMonitor().reportError(error);
    }

    return false;
  }
});
